<template>
  <div id="register">
    <div class="fields">
      <m-select
        v-model="fields.address.country.value"
        :options="countryOptions"
        :loading="fields.address.country.loading"
        :disabled="fields.address.country.disabled"
        :label="$t(fields.address.country.label)"
        :rules="fields.address.country.rules"
        :success="fields.address.country.success"
        :error="fields.address.country.error"
        max-height="152px"
        :checkbox="false"
        :order="false"
        dark
        outlined
        vertical
        color="secondary"
        class="control"
      />

      <template v-if="countrySelected">
        <v-text-field
          v-model="fields.phone.value"
          :key="'phone-' + (fields.phone.mask || '')"
          v-mask="fields.phone.mask || ''"
          :loading="fields.phone.loading||loading"
          :label="$t(fields.phone.label)"
          :hint="fields.phone.hint"
          :rules="fields.phone.rules"
          :success="fields.phone.success"
          :error="fields.phone.error"
          type="tel"
          outlined
          color="secondary"
          class="control"
          @input="check"
        >
          <template v-slot:message="data">
            {{ $t(data.message) }}
          </template>
        </v-text-field>

        <v-text-field
          v-model="fields.cpf.value"
          :key="'cpf-' + (fields.cpf.mask || '')"
          v-mask="fields.cpf.mask || ''"
          :loading="fields.cpf.loading"
          :label="$t(fields.cpf.label)"
          :hint="fields.cpf.hint"
          :rules="fields.cpf.rules"
          :success="fields.cpf.success"
          :error="fields.cpf.error"
          type="tel"
          outlined
          color="secondary"
          class="control"
        >
          <template v-slot:message="data">
            {{ $t(data.message) }}
          </template>
        </v-text-field>

        <v-text-field
          v-model="fields.fullname.value"
          :loading="fields.fullname.loading"
          :disabled="fields.fullname.disabled"
          :label="$t(fields.fullname.label)"
          :hint="fields.fullname.hint"
          :rules="fields.fullname.rules"
          :success="fields.fullname.success"
          :error="fields.fullname.error"
          outlined
          color="secondary"
          class="control"
        >
          <template v-slot:message="data">
            {{ $t(data.message) }}
          </template>
        </v-text-field>

        <v-text-field
          v-model="fields.email.value"
          :loading="fields.email.loading"
          :disabled="fields.email.disabled"
          :label="$t(fields.email.label)"
          :hint="fields.email.hint"
          :rules="fields.email.rules"
          :success="fields.email.success"
          :error="fields.email.error"
          type="email"
          outlined
          color="secondary"
          class="control"
        >
          <template v-slot:message="data">
            {{ $t(data.message) }}
          </template>
        </v-text-field>

        <v-text-field
          v-model="fields.address.zip.value"
          :key="'zip-' + (fields.address.zip.mask || '')"
          v-mask="fields.address.zip.mask || ''"
          :loading="fields.address.zip.loading"
          :label="$t(fields.address.zip.label)"
          :hint="fields.address.zip.hint"
          :rules="fields.address.zip.rules"
          :success="fields.address.zip.success"
          :error="fields.address.zip.error"
          type="tel"
          outlined
          color="secondary"
          class="control"
        >
          <template v-slot:message="data">
            {{ $t(data.message) }}
          </template>
        </v-text-field>

        <m-select
          v-model="fields.vehicle.model.value"
          :options="vehicleList"
          :loading="fields.vehicle.model.loading"
          :label="$t(fields.vehicle.model.label)"
          :hint="fields.vehicle.model.hint"
          :rules="fields.vehicle.model.rules"
          :success="fields.vehicle.model.success"
          :error="fields.vehicle.model.error"
          max-height="80vw"
          searchable
          dark
          outlined
          vertical
          color="secondary"
          class="control"
        />

        <v-text-field
          v-model="fields.vehicle.year.value"
          :loading="fields.vehicle.year.loading"
          :label="$t(fields.vehicle.year.label)"
          :hint="fields.vehicle.year.hint"
          :rules="fields.vehicle.year.rules"
          :success="fields.vehicle.year.success"
          :error="fields.vehicle.year.error"
          type="tel"
          outlined
          color="secondary"
          class="control"
        >
          <template v-slot:message="data">
            {{ $t(data.message) }}
          </template>
        </v-text-field>

        <m-select
          v-model="fields.job.service_model.value"
          :options="translate(fields.job.service_model.items, ['text', 'caption'])"
          :loading="fields.job.service_model.loading"
          :disabled="fields.job.service_model.disabled"
          :label="$t(fields.job.service_model.label)"
          :placeholder="fields.job.service_model.placeholder"
          :hint="fields.job.service_model.hint"
          :rules="fields.job.service_model.rules"
          :success="fields.job.service_model.success"
          :error="fields.job.service_model.error"
          outlined
          dark
          vertical
          color="secondary"
          class="control"
        />

        <m-select
          v-model="fields.job.fulltime.value"
          :options="translate(fields.job.fulltime.items)"
          :loading="fields.job.fulltime.loading"
          :disabled="fields.job.fulltime.disabled"
          :label="$t(fields.job.fulltime.label)"
          :placeholder="fields.job.fulltime.placeholder"
          :hint="fields.job.fulltime.hint"
          :rules="fields.job.fulltime.rules"
          :success="fields.job.fulltime.success"
          :error="fields.job.fulltime.error"
          outlined
          dark
          vertical
          color="secondary"
          class="control"
        />

        <m-select
          v-model="fields.job.journey.value"
          :options="translate(fields.job.journey.items)"
          :loading="fields.job.journey.loading"
          :disabled="fields.job.journey.disabled"
          :label="$t(fields.job.journey.label)"
          :placeholder="fields.job.journey.placeholder"
          :hint="fields.job.journey.hint"
          :rules="fields.job.journey.rules"
          :success="fields.job.journey.success"
          :error="fields.job.journey.error"
          outlined
          dark
          vertical
          color="secondary"
          class="control"
        />

        <v-text-field
          v-model="fields.email_indicacao.value"
          :loading="fields.email_indicacao.loading"
          :label="$t(fields.email_indicacao.label)"
          :placeholder="$t(fields.email_indicacao.placeholder)"
          type="email"
          outlined
          color="secondary"
          class="control"
          @focus="fields.email_indicacao.toggle = true"
        >
          <template #prepend-inner>
            <v-icon class="mr-2">{{ fields.email_indicacao.toggle ? icons.checked : icons.unchecked }}</v-icon>
          </template>
        </v-text-field>
      </template>
    </div>

    <v-btn
      v-if="countrySelected"
      :loading="loading"
      :elevation="0"
      block
      large
      class="control black--text"
      :color="progress<100 ? 'warning' : 'primary'"
      @click="send"
    >
      {{ cta }}
    </v-btn>
  </div>
</template>

<style lang="scss">
  
  #register {
    .control {
      margin: 4px 0 12px !important;
    }
    .control ~ .hint {
      display: block;
      margin: -24px 0 24px;
      padding: 0 12px;
    }
    
    .error {
      color: var(--v-warning-base) !important;
    }
    .error--text {
      color: var(--v-warning-base) !important;
      caret-color: var(--v-warning-base) !important;
    }
  }
  .select-menu.secondary {
    border: 1px solid var(--v-secondary-base) !important;
  }
  .select-menu.secondary .v-list-item--active {
    color: var(--v-secondary-base) !important;
  }
</style>

<script>
  import services from '@/services.js'
  import { fields, formatter, parser } from '@/services/profile.js'
  import { profile as dictionary } from '@/dictionary'
  import { sync, get } from 'vuex-pathify'
  import { mask } from 'vue-the-mask'
  import {
    mdiCheckboxBlankOutline, 
    mdiCheckboxMarked,
  } from '@mdi/js'
  import axios from 'axios';


  export default {
    data: () => ({
      icons: {
        checked: mdiCheckboxMarked,
        unchecked: mdiCheckboxBlankOutline,
      },
      fields: {
        ...fields,
        email_indicacao: {
          toggle: false,
          value: null,
          label: 'login.has_referral',
          placeholder: 'login.referral_email',
        },
      },
      validated: [],
      required: [
        'fullname',
        'email',
        'cpf',
        'phone',
        'address.country',
        'address.zip',
        'job.service_model',
        'job.fulltime',
        'job.journey',
        'vehicle.model',
        'vehicle.year',
      ],
      hidden: [
        'address.street',
        'address.neighborhood',
        'address.city',
        'address.state',
      ],
      loading: false,
    }),
    computed: {
      user: sync('user'),
      vehicles: get('app/views@help.vehicles'),
      toast: sync('app/toast'),
      countries: sync('app/countries'),

      cta () {
        const invalid = this.invalid.length;
        const label = this.$t(invalid > 0 ? 'login.start.register.progress' : 'login.start.register.title', { n: invalid });
        return label;
      },

      progress () {
        const invalid = this.invalid.length;
        const required = this.required.length;
        
        return Math.round((required - invalid) / required * 100);
      },

      invalid () {
        const fields = this.fields;
        const invalid = _.reduce(this.required, (invalid, key) => {
          const field = _.get(fields, key);
          const regex = field.regex||new RegExp(this.maskToRegex(field.mask));
          const valid = !_.has(field, 'rules')||_.every(field.rules, rule => rule(field.value, this, regex)===true);
          if (!valid) {
            // console.log('invalid', key);
            invalid.push(key);
          }
          return invalid;
        }, []);
        return invalid;
      },

      vehicleList () {
        return _.uniq(_.map(this.vehicles, 'model'));
      },

      countryOptions () {
        const locale = this.$i18n.locale;
        const lang = locale.split('-')[0];
        console.log('countryOptions', locale, lang);
        return _.orderBy(_.map(_.cloneDeep(this.countries), country => ({
          text: country.translations[lang] || country.name,
          value: country.iso2,
          emoji: country.emoji,
          operational: country.operational,
        })), [country => country.operational ? 1 : 0, 'text'], ['desc', 'asc']);
      },

      countrySuggestion () {
        // Auto-select country based on locale
        const locale = this.$i18n.locale;
        // Map locale to country code: pt-br -> BR, es-ar -> AR
        const localeToCountry = {
          'pt-br': 'BR',
          'es-ar': 'AR',
          'es-py': 'PY'
        };
        return localeToCountry[locale] || null;
      },

      countrySelected () {
        return !!this.fields.address.country.value;
      },
    },
    watch: {
      $route: {
        immediate: true,
        deep: true,
        handler (route) {
          // look for query email-indicacao
          const email_indicacao = _.get(route.query, 'email-indicacao', null);
          if (email_indicacao) {
            this.fields.email_indicacao.value = decodeURIComponent(email_indicacao);
            this.fields.email_indicacao.toggle = true;
          }
          // CPF for this signup flow comes from the login step (authoritative), not from vuex:
          // profile.cpf is loaded from the API on signup/profile fetch.
          const cpfQuery = _.get(route.query, 'cpf', null);
          if (cpfQuery) {
            this.fields.cpf.value = this.rawCPF(cpfQuery);
          }
          const phoneQuery = _.get(route.query, 'phone', null) || _.get(route.query, 'username', null);
          if (phoneQuery) {
            this.fields.phone.value = phoneQuery;
          }
        }
      },
      countrySuggestion: {
        immediate: true,
        handler (localeCountry) {
          if (this.fields.address.country.value) {
            this.applyCountryMasks(this.fields.address.country.value);
            return;
          }

          const code = localeCountry || _.get(this.user, 'profile.address.country');
          if (code) {
            this.fields.address.country.value = code;
          }
        }
      },
      'fields.address.country.value': {
        handler (countryCode) {
          if (!countryCode) return;
          this.applyCountryMasks(countryCode);
        },
        immediate: true
      },
      countries (list) {
        if (!_.isEmpty(list) && this.fields.address.country.value) {
          this.applyCountryMasks(this.fields.address.country.value);
        }
      },
      invalid (invalid) {
        _.each(this.required, key => {
          if (!_.includes(invalid, key)) {
            if (!_.includes(this.validated, key)) {
              const field = _.get(this.fields, key);
              if (field.error) {
                field.error = false;
              }
              if (key=='address.zip') {
                this.getZipAddress(field.value);
              }
              this.validated.push(key);
            }
          }else{
            if (_.includes(this.validated, key)) {
              const i = this.validated.indexOf(key);
              this.validated.splice(i,1)
            }
          }
        });
      },
      user: {
        immediate: true,
        deep: true,
        handler (user) {
          // Do not bind fields.cpf to vuex: profile.cpf is set when profile loads.
          const email = _.get(user, 'profile.email');
          this.fields.email.value = email || null;
        }
      }
    },
    methods: {
      ...services,
      parser,

      applyCountryMasks (countryCode) {
        if (!countryCode) return;

        this.user.profile.address.country = countryCode;

        const country = this.countries.find(c => c.iso2 === countryCode);
        if (country?.cities) {
          if (country.cities.length === 1) {
            this.fields.address.city.value = country.cities[0];
          } else {
            this.fields.address.city.value = null;
            this.fields.address.city.items = country.cities;
          }
        }
        if (country?.states) {
          if (country.states.length === 1) {
            this.fields.address.state.value = country.states[0];
          } else {
            this.fields.address.state.value = null;
            this.fields.address.state.items = country.states;
          }
        }
        if (country?.masks) {
          _.each(country.masks, (mask, key) => {
            const field = _.get(this.fields, key);
            if (!field || typeof field !== 'object' || mask == null) return;

            _.set(this.fields, `${key}.mask`, mask);

            const pattern = Array.isArray(mask) ? mask[0] : mask;
            if (typeof pattern !== 'string' || !pattern) return;

            _.set(this.fields, `${key}.regex`, new RegExp(this.maskToRegex(pattern)));
            _.set(this.fields, `${key}.rules`, [(v, $, regex) => !!v && (!regex || regex.test(v)) || 'general.mandatory_field']);
          });
        } else {
          const fieldsToReset = ['cpf', 'phone', 'address.zip'];
          _.each(fieldsToReset, (fieldKey) => {
            const field = _.get(this.fields, fieldKey);
            if (field && _.has(field, 'mask')) {
              _.set(this.fields, `${fieldKey}.mask`, undefined);
              if (_.has(field, 'regex')) {
                _.set(this.fields, `${fieldKey}.regex`, null);
              }
            }
          });
        }
      },

      check (input) {
        if (this.invalid.includes('phone')||this.loading) return;
        const phone = this.rawData(input != null ? input : this.fields.phone.value);
        if (!phone) return;
        console.log('checkUser', phone);
        this.loading = true;
        this.$emit('check', phone);
      },

      validate () {
        const invalid = this.invalid;
        _.each(invalid, key => {
          const field = _.get(this.fields, key);
          field.error = true;
        });
      },  

      send () {
        const fields = this.fields;
        const payload = _.reduce([...this.required, ...this.hidden, 'email_indicacao'], (payload, key) => {
          const field = _.get(fields, key);
          _.each(formatter({ [key]: field.value }, this), (value, key) => {
            console.log(key, value);
            if (value!==null) {
              _.set(payload, this.translateNotation(key, dictionary), value);
            }
          })
          return payload;
        }, {});

        if (this.$i18n && this.$i18n.locale) {
          payload.locale = this.$i18n.locale;
        }

        console.log('send => ', payload);
        if (this.invalid.length > 0) {
          this.validate();
          return;
        }
        this.loading = true;
        this.$api
          .post(process.env.VUE_APP_ROOT_API+'/driver/signup/?source=app', payload)
          .then(response => {
            console.log('send => ', response);
            _.each(this.parser(response.data, this), (v,k) => {
              this.$set(this.user.profile, k, v);
            });
            console.log('org', this.user.profile.fleet.id_organization);
            
            this.$emit('go-to', 'login', { username: this.rawData(fields.phone.value) });
          })
          .catch(error => {
            console.log('send !> ', error);
            // TODO show error
            this.toggleToast(
              true,
              error.response?.data || this.$t('errors.generic'),
              5000
            );
          })
          .finally(() => {
            this.loading = false;
          });
      },

      getZipAddress (zip) {
        if (this.fields.address.country.value && this.fields.address.country.value !== 'BR') return;
        // this.fields.address.zip.loading = true;
        // axios(`https://nominatim.openstreetmap.org/search?postalcode=${zip}&format=json&addressdetails=1`)
        axios(`https://viacep.com.br/ws/${zip}/json/`)
        .then(response => {
          console.log('/getZipAddress', response);
          if (!_.has(response.data, 'erro')) {
            const { 
              logradouro: street,
              bairro: neighborhood,
              localidade: city,
              uf: state,
              country='BR',
            } = response.data;
            this.fields.address.street.value = street;
            this.fields.address.neighborhood.value = neighborhood;
            this.fields.address.city.value = city
            this.fields.address.state.value = state;
            this.fields.address.country.value = country;
            console.log('getZipAddress', street, neighborhood, city, state, country);
            
          }
        });
      },
    },
    components: {
      MSelect: () => import('@/components/mSelect'),
    },
    directives: {
      mask,
    }
  }
</script>